module.exports = __webpack_public_path__ + "static/img/process-08.35adacc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/process-08.png
// module id = 4lHX
// module chunks = 0